import token from 'styled-token';
import { spacingMixin } from '../spacingMixin';
var maskCSS = function maskCSS(props) {
  if (!props.enabled) {
    return '';
  }
  return token('Mask.backgroundColor', function (backgroundColor) {
    return "\n            position: relative;\n            user-select: none;\n            &:after {\n                content: '';\n                background-color: " + (backgroundColor || '') + ";\n                opacity: 0.5;\n                position: absolute;\n                top: 0;\n                left: 0;\n                height: 100%;\n                width: 100%;\n            }\n        ";
  })(props);
};

/** @class MaskMixin */
/** @method */
export var MaskMixin = function MaskMixin(props) {
  return [maskCSS(props), spacingMixin(props)];
};